import { createContext } from 'react'

import { createDraggableModalStore } from '../store'

export const DraggableModalStoreContext = createContext<
  ReturnType<typeof createDraggableModalStore> | undefined
>(undefined)
